export const IMPORTED_ORGANIZATION_BASE_ROUTE = '/importorganizations';

export const IMPORTED_ORGANIZATION_MODULE_KEY = 'importOrganizations';
export const IMPORTED_ORGANIZATION_FILTER_KEY = 'importOrganizations';
